export default __webpack_public_path__ + "static/media/gloves-for-truck-drivers.006fa92f.png";